import { dateFormatter } from '@fareye/common'
import { isEmpty, startCase, formatMs } from '@fareye/utils'
export const displayTime = (time: any, formatter?: string) =>
  time ? dateFormatter(time, formatter) : '-'

const regex = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/

export const formatDateTimeForCSV = (data: any, columnsToDisplay: any) => {
  const transportMode: string[] = Object.keys(data)
  let result: any[] = []
  let columns: any[] = []
  let recordList: any = []
  transportMode.forEach((mode: string) => {
    result.push([mode?.toUpperCase()])
    columns = mode ? columnsToDisplay[mode] : columnsToDisplay['road']
    result.push(columns.map((item: any) => item.label))
    data[mode].forEach((record: any) => {
      columns.forEach(({ key, formatter }: any) => {
        let val
        if (record?.hasMultiVehicle && key === 'vehicleNo') {
          val =
            Object.values(record?.multiVehicleHistory)
              .sort((a: any, b: any) => b.sequence - a.sequence)
              .map((ele: any) => ele.vehicleNo) || []
        } else {
          val = record[key] ? record[key] : getValue(key, record)
          val = formatter ? displayTime(val) : val
        }
        recordList.push(val)
      })
      result.push(recordList)
      recordList = []
    })
    result.push([' '])
  })
  return result
}

export const formatItemLabelForCSV = (data: any, columnsToDisplay: any) => {
  let result: any[] = []
  let columnObject = columnsToDisplay
  data.forEach((dataObject: any) => {
    let recordData = columnObject.reduce((recordData: any, arrayItem: any) => {
      let val
      const label = arrayItem['label'].toUpperCase()
      if (label == 'DIMENSION') {
        val = [
          dataObject['itemLength'],
          dataObject['itemWidth'],
          dataObject['itemHeight']
        ].join('X')
      } else {
        val = dataObject[arrayItem['key']] || '-'
      }
      recordData[label] = val
      return recordData
    }, {})
    result.push(recordData)
  })
  return result
}

const getValue = (key: string, data: any) => {
  switch (key) {
    case 'arrivalTime':
      return data?.ata?.time
        ? displayTime(data.ata)
        : data?.eta?.time
        ? displayTime(data.eta)
        : '-'
    case 'oceanArrivalTime':
      return data?.ata?.time
        ? displayTime(data.ata)
        : data?.sta?.time
        ? displayTime(data.sta)
        : '-'
    case 'route':
      return `${data?.attachLocation?.locationName} - ${data?.detachLocation?.locationName}`
    case 'shipmentRoute':
      return `${data?.startLocation?.locationName} - ${data?.endLocation?.locationName}`
    case 'departureTime':
      return data?.atd?.time
        ? displayTime(data.atd)
        : data?.etd?.time
        ? displayTime(data.etd)
        : '-'
    case 'oceanDepartureTime':
      return data?.atd?.time
        ? displayTime(data.atd)
        : data?.etd?.time
        ? displayTime(data.etd)
        : '-'
    case 'routeState':
      return `${data?.inState ? startCase(data.inState) : '-'} ${
        data?.status ? startCase(data.status) : '-'
      }`
    case 'packageRouteState':
      return `${data?.routeState ? startCase(data.routeState) : '-'}`
    case 'transshipment':
      return `${
        !isEmpty(data.transshipment) ? data.transshipment.join(' , ') : 'Direct'
      }`
    case 'images':
      const photos = Object.keys(data).filter(
        (key: string) =>
          key.toLowerCase().includes('photo') &&
          data[key] !== null &&
          regex.test(data[key])
      )
      let finalVal: string = ''
      photos.forEach((key: string, index: number) => {
        finalVal =
          finalVal + data[key] + `${photos.length == index + 1 ? '' : '\n'}`
      })
      return finalVal
    case 'signature':
      return data?.epodSignature || ''
    case 'durationFormat':
      return formatMs(data.duration * 1000)
    case 'loadsensorWeight':
      return data?.extraData?.weight
  }
}

export const formatForCSV = (data: any, columnsToDisplay: any) => {
  let columns: any[] = columnsToDisplay.map((item: any) => item.label)
  let result: any[] = [columns]
  data.forEach((item: any, index: number) => {
    let record: any = []
    columnsToDisplay.forEach((col: any) => {
      let val: any = item[col.key] ? item[col.key] : getValue(col.key, item)
      val = col.formatter ? displayTime(val) : val
      record.push(val)
    })
    result.push(record)
  })
  return result
}

export const haversineDistance = (
  [lat1, lon1]: [number, number],
  [lat2, lon2]: [number, number],
  isMiles = false
) => {
  const toRadian = (angle: number) => (Math.PI / 180) * angle
  const distance = (a: number, b: number) => (Math.PI / 180) * (a - b)
  const RADIUS_OF_EARTH_IN_KM = 6371

  const dLat = distance(lat2, lat1)
  const dLon = distance(lon2, lon1)

  lat1 = toRadian(lat1)
  lat2 = toRadian(lat2)

  // Haversine Formula
  const a =
    Math.pow(Math.sin(dLat / 2), 2) +
    Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2)
  const c = 2 * Math.asin(Math.sqrt(a))

  let finalDistance = RADIUS_OF_EARTH_IN_KM * c

  if (isMiles) {
    finalDistance /= 1.60934
  }

  return finalDistance
}
